// import { ElMessage, ElMessageBox } from 'element-plus';
import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import type { PureHttpRequestConfig, RequestMethods, PureHttpResponse, CustomAxiosRequestConfig, responseType } from './types';
import { localSToken } from './storage';
const defaultConfig: AxiosRequestConfig = {
    // 请求超时时间
    timeout: 10000,
    headers: {
        Accept: "application/json, text/plain, */*",
        // "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    }, 
    // baseURL: "http://175.27.130.210:8081/"
    baseURL:"/api/"
};
class http {
    constructor() {
        this.httpInterceptorsRequest();
        this.httpInterceptorsResponse();
    }
    private static axiosInstance: AxiosInstance = axios.create(defaultConfig);
    /** 请求拦截 待完善*/
    private httpInterceptorsRequest(): void {
        http.axiosInstance.interceptors.request.use(
            async (config: PureHttpRequestConfig): Promise<any> => {
                config.setPorpsFunc?.("loadingShow", true)//调用封装的公共数据修改方法
                config.headers = {
                    ...config.headers,
                    token: localSToken().get()
                };
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
    }

    /** 响应拦截 待完善*/
    private httpInterceptorsResponse(): void {
        const instance = http.axiosInstance;
        instance.interceptors.response.use(
            (response: PureHttpResponse) => {
                if (response.data.code == 0) {
                    if (!response.request.responseURL.includes("query")) {
                    }

                } if (response.data.code == 1010) {
                    // 让用户返回首页
                    console.log(response.data.code)
                    window.location.href = '';
                }

                return response.data;
            },

        );
    }

    /**通用请求 */
    public request<T>(
        method: RequestMethods,
        url: string,
        data?: AxiosRequestConfig,
    ): Promise<T> {
        const config = {
            method,
            url,
            ...data,

        } as AxiosRequestConfig
        return new Promise((resolve, reject) => {
            http.axiosInstance.request(config)
                .then((res: any) => {
                    resolve(res)

                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    /**GET请求传入请求地址，和{params:{数据}} */
    public get<T, P>(
        url: string,
        params?: CustomAxiosRequestConfig<T>,//源码中params是any需要加限制所以不能使用AxiosRequestConfig
    ): Promise<responseType<P>> {
        return this.request("get", url, params,)
    }
    /**GET请求传入请求地址，和{data:{数据}} */
    public post<T, P>(
        url: string,
        data?: AxiosRequestConfig<T>,
    ): Promise<responseType<P>> {
        return this.request("post", url, data)

    }
    /** 上传文件 */
    public uploadFil(
        url: string,
        file: File,
        params?: Record<string, any>
    ): Promise<any> {
        // 构建 FormData
        const formData = new FormData();
        formData.append('file', file);

        // 将其他参数添加到 FormData 中
        if (params) {
            Object.keys(params).forEach(key => {
                formData.append(key, params[key]);
            });
        }

        // 使用 Axios 发送 POST 请求上传文件
        return http.axiosInstance.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }


}
export default new http()
